import { useEffect, useState } from "react";
import BackButton from "../../../Components/BackButton";
import RankingTable from "../../../Components/RankinkTable";
import TitlePages from "../../../Components/TitlePages";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import {
  Container,
  SizeContainer,
  Header,
  MainContainer,
  Container1
} from "./style";
import Loading from "../../../Components/Loading";
import { useGame } from "../../../providers/GameContext";
import CountUp from "react-countup";
import { useRankingMarketPlace } from "../../../providers/RankingMarketContext";

const RankingMarketplace = () => {
  const [key, setKey] = useState('actual-market');
  const { activeGame, allGames } = useGame()
  const { rankingInActualGamesFilteredByRound,
    setupRankings,
    loading,
    marketInActualGame,
    fetchRoundsInGame,
    fetchMarketInActualGame,
    rounds,
    globalRankingMarket
  } = useRankingMarketPlace()

  useEffect(() => {
    if (marketInActualGame?.length === 0) return
    setupRankings()
  }, [marketInActualGame, rounds])

  useEffect(() => {
    if (!activeGame?.jogo) return
    fetchMarketInActualGame()
    fetchRoundsInGame()
  }, [activeGame])

  return (
    <Container>
      <SizeContainer>
        <TitlePages text="Ranking Supermercado" />
        <Header>
          <BackButton path="/menuMarketplace" />
        </Header>
        <MainContainer>

          <Tabs
            style={{
              width: '100%',
              justifyContent: 'center',
              paddingTop: 10,
            }}
            id="controlled-tab-example"
            fill
            activeKey={key}
            onSelect={(k) => setKey(k)}
            className="mb-3"
          >
            <Tab eventKey="actual-market" title="Jogo Atual">
              {loading ? (
                <Loading />
              ) : rankingInActualGamesFilteredByRound?.length === 0 ? <span style={{
                borderRadius: '15px',
                textAlign: 'center',
                fontSize: '18px',
                display: 'flex',
                alignSelf: 'center',
                justifyContent: 'center',

                alignItems: 'center',
                fontWeight: 'bold',
                width: '100%',
                padding: "15px",
                backgroundColor: '#fa821f'
              }}>Nenhum supermercado jogou.</span> : rankingInActualGamesFilteredByRound?.map((item, index) => (
                <RankingTable index={(index + 1)} key={index} content={item} />
              ))
              }
            </Tab>
            <Tab style={{ width: '100%' }} eventKey="acumulated-market" title="Acumulado">
              {loading ? (
                <Loading />
              ) : globalRankingMarket?.length === 0 ? <span style={{
                borderRadius: '15px',
                textAlign: 'center',
                fontSize: '18px',
                fontWeight: 'bold',
                width: '100%',
                padding: "15px",
                backgroundColor: '#fa821f'
              }}>Nenhum supermercado jogou.</span> : globalRankingMarket?.map((item, index) => (
                <Container1>
                  <tr key={index}>
                    <td className='nameRow'>{item.nome}</td>
                    <td>
                      <CountUp
                        style={{ color: item.margemBruta < 0 ? 'red' : '#2AFAA5' }}
                        end={item.margemBruta}
                        prefix=" R$ "
                        separator="."
                        decimal=","
                        decimals={2}
                        duration={0.5}
                      />
                    </td>
                  </tr>
                </Container1>
              ))
              }
            </Tab>
          </Tabs>
        </MainContainer>
      </SizeContainer>
    </Container>
  );
};
export default RankingMarketplace;
